import { useEffect } from 'react';
import { useTenantContext } from '@trashlab/sitesapp/src/contexts/use-tenant-context';
import { initAnalytics } from '@trashlab/sitesapp/src/lib/analytics-tracker';
import env from '@trashlab/sitesapp/src/env';

export const AnalyticsTracker = () => {
  const { website, isPreview } = useTenantContext();

  useEffect(() => {
    // Don't initialize analytics if in website customization in the viteapp
    if (isPreview) {
      return;
    }

    if (!website?.id) return;

    // Initialize analytics tracker
    const tracker = initAnalytics({
      websiteId: website.id,
      apiBaseUrl: env.NEXT_PUBLIC_APP_HOST,
      debug: process.env.NODE_ENV === 'development',
      // Exclude admin paths and API routes from tracking
      excludePaths: ['/admin/*', '/api/*'],
    });

    // Cleanup on unmount
    return () => {
      tracker.destroy();
    };
  }, [website?.id, isPreview]);

  return null;
};
